import react from 'react'
import { parseMessage, reactionInfo } from '../../Scout/Pages/ScoutMessageComponent'
import { Box, Tooltip, ListItem, List, TextField, Typography } from '@mui/material'
import dayjs from 'dayjs'
import { transformTimeData } from '../../Scout/Pages/ChatList'
import ScoutMessageComponent from '../../Scout/Pages/ScoutMessageComponent'

import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PersonIcon from '@mui/icons-material/Person';
import ComputerIcon from '@mui/icons-material/Computer';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import DescriptionIcon from '@mui/icons-material/Description';
import BusinessIcon from '@mui/icons-material/Business';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ScheduleIcon from '@mui/icons-material/Schedule';
import TaskAltIcon from '@mui/icons-material/TaskAlt';

import { formatCurrency } from '../../Journeys/functions'
import { currencyPrefix } from '../../Journeys/single-card'

import KwikMarkdown from '../../../utils/kwikmarkdown'
import { CommentBoxTextField } from '../../Journeys/commentbox'

import { renderHistoryPlainContent } from '../../Chat/MessagesArea/ChatWindow/MessageArea/MemoMessage/KwikMessageRenderer'

const user_icons = {
    SYSTEM: <ComputerIcon />,
    CONTACT: <PersonIcon />,
    AGENT: <SupportAgentIcon />
}

const toUserId = (user) => {
    switch (user) {
        case 'CONTACT': return 0;
        case 'AGENT': return 1;
        case 'SYSTEM': return -3;
        default: return -3;
    }
};

const OpportunityDetailRow = ({ icon, label, value, children }) => (
    <Box
        sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1.5,
        }}
    >
        <Box
            sx={{
                color: "text.secondary",
                display: "flex",
                mt: "2px",
            }}
        >
            {icon}
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                    display: "block",
                    fontWeight: 600,
                    textTransform: "uppercase",
                }}
            >
                {label}
            </Typography>

            {children || (
                <Typography variant="body2">
                    {value || "-"}
                </Typography>
            )}
        </Box>
    </Box>
);

const RenderDetail = ({ detail, data, contact, editMode }) => {
    return (
        <>
            {detail === 'uniqueid' &&
                <>
                    {data.uniqueid}
                </>
            }
            {detail === 'messages' &&
                <List className='contact-profile-detail-list' disablePadding>
                    {data.messages.map(message =>
                        <ListItem className={`contact-profile-detail-list ${message.user}`} disablePadding>
                            {message.user === 'CONTACT' ?
                                <Box className='flex'>
                                    <Tooltip title={dayjs(message.date).format('DD/MM/YYYY HH:mm')}><span style={{ minWidth: '3rem' }}>[{dayjs(message.date).format('HH:mm')}]</span></Tooltip>
                                    <span>{user_icons[message.user]}</span>
                                    <span>:</span>
                                    <span style={{ maxWidth: '20rem' }}>
                                        {renderHistoryPlainContent(message.text, {
                                            accountcode: data?.accountcode,
                                            user_id: toUserId(message.user),
                                            date: message.date,
                                        })}
                                    </span>
                                </Box>
                                :
                                <Box className='flex'>
                                    <span style={{ maxWidth: '20rem', textAlign: 'end' }}>
                                        {renderHistoryPlainContent(message.text, {
                                            accountcode: data?.accountcode,
                                            user_id: toUserId(message.user),
                                            date: message.date,
                                        })}
                                    </span>
                                    <span>:</span>
                                    <span>{user_icons[message.user]}</span>
                                    <Tooltip title={dayjs(message.date).format('DD/MM/YYYY HH:mm')}><span style={{ minWidth: '3rem' }}>[{dayjs(message.date).format('HH:mm')}]</span></Tooltip>

                                </Box>}
                        </ListItem>
                    )}
                </List>
            }
            {detail === 'inout' &&
                <>
                    {data.custom_field2_value}, {data.origin} → {data.destination}, {data.status}.
                </>
            }
            {detail === 'scout_last_message' &&
                <List className='scout-window-content-list reverse'>
                    {data.messages.
                        flatMap((message, index, messages) => {
                            if (!message.type && message.messageType !== 'reactionMessage')
                                return (
                                    <ScoutMessageComponent 
                                        message={message} 
                                        index={index} 
                                        chatType={'CONTACT'} 
                                        messages={data.messages} 
                                        parent={data} 
                                        setPrevState={data.setState} 
                                        setLoading={() => { }} 
                                        previousMessage={index > 0 ? messages.filter(m => !m.type && m.messageType !== 'reactionMessage')[index - 1] : null}
                                    />
                                )
                        })}
                </List>
            }
            {detail === 'status_update' &&
                <Box>
                    {data.status_update}
                </Box>
            }
            {detail === 'opportunity_update' &&
                <Box sx={{ padding: ".5rem" }} dangerouslySetInnerHTML={{ __html: data.update }} />
            }

            {detail === 'opportunity_comment' &&
            <>
            {
                editMode?.id === data.originId ? 
                <CommentBoxTextField 
                    defaultValue={data.text}
                    onChange={({target}) => data.changecallback(target.value)}
                    id={editMode?.id}
                />
                :
                <KwikMarkdown>{data.text}</KwikMarkdown>
            }
            </>
                
            }
            {detail === 'opportunity_details' &&
                <Box className="opportunity-details-grid">
                    {data.description && (
                        <Box sx={{ gridColumn: { sm: "1 / -1" } }}>
                            <OpportunityDetailRow
                                icon={<DescriptionIcon fontSize="small" />}
                                label="Descrição"
                            >
                                <KwikMarkdown>{data.description}</KwikMarkdown>
                            </OpportunityDetailRow>
                        </Box>
                    )}

                    {data.column_name && (
                        <OpportunityDetailRow
                            icon={<ViewWeekIcon fontSize="small" />}
                            label="Estágio (coluna)"
                            value={data.column_name}
                        />
                    )}

                    {data.owner_name && (
                        <OpportunityDetailRow
                            icon={<PersonIcon fontSize="small" />}
                            label="Vendedor"
                            value={data.owner_name}
                        />
                    )}

                    {data.contact_enterprise_name && (
                        <OpportunityDetailRow
                            icon={<BusinessIcon fontSize="small" />}
                            label="Empresa"
                            value={data.contact_enterprise_name}
                        />
                    )}

                    {data.value && (
                        <OpportunityDetailRow
                            icon={<AttachMoneyIcon fontSize="small" />}
                            label="Valor"
                            value={`${currencyPrefix[data.currency]}${formatCurrency(data.value, data.currency)}`}
                        />
                    )}

                    {data.created_at && (
                        <OpportunityDetailRow
                            icon={<EventAvailableIcon fontSize="small" />}
                            label="Criado em"
                            value={dayjs.utc(data.created_at).local().format("DD/MM/YYYY HH:mm")}
                        />
                    )}

                    {data.estimated_at && (
                        <OpportunityDetailRow
                            icon={<ScheduleIcon fontSize="small" />}
                            label="Estimado para"
                            value={dayjs.utc(data.estimated_at).local().format("DD/MM/YYYY HH:mm")}
                        />
                    )}

                    {data.closed_at && (
                        <OpportunityDetailRow
                            icon={<TaskAltIcon fontSize="small" />}
                            label="Fechado em"
                            value={dayjs.utc(data.closed_at).local().format("DD/MM/YYYY HH:mm")}
                        />
                    )}
                </Box>
            }
        </>
    )
}

export default RenderDetail
